import { MEDIA_CHANNELS } from "../../../constants";
import PropTypes from "prop-types";
import {
  Facebook,
  Instagram,
  Snapchat,
  TikTok,
  LinkedIn,
} from "../../../assets/customIcons";

export const SocialPageIcon = ({ mediaChannel, hasSocialAccount = true }) => {
  const cssClass = hasSocialAccount
    ? {}
    : {
        className: "no-social-account",
        sx: { color: "#ea580c", cursor: "default" },
      };

  switch (mediaChannel) {
    case MEDIA_CHANNELS.facebook:
      return <Facebook {...cssClass} />;

    case MEDIA_CHANNELS.instagram:
      return <Instagram {...cssClass} />;

    case MEDIA_CHANNELS.snapchat:
      return <Snapchat {...cssClass} />;

    case MEDIA_CHANNELS.tiktok:
      return <TikTok {...cssClass} />;

    case MEDIA_CHANNELS.linkedin:
      return <LinkedIn {...cssClass} />;

    default:
      return <></>;
  }
};

SocialPageIcon.propTypes = {
  mediaChannel: PropTypes.string.isRequired,
  hasSocialAccount: PropTypes.bool,
};
